//#region Libraries
import { useState } from "react";
//#endregion
//#region Services
import {
	requestGetEventTypes,
	requestGetEventSubtypes,
	requestGetEventGraphics,
	requestGetOrganizers,
	requestGetComplementaryServiceAreas,
	requestGetExtracurricularSections,
} from "services/events/relatedToEvents";
import { requestGetCertificationSignatureTypes } from "services/events/certification";
import {
	requestGetModalities,
	requestGetLocations,
	requestGetAllDays,
	requestGetAllCampus,
	requestGetCampusEnvironments,
	requestGetTeacherAccounts,
	requestGetInscriptionEventTypes,
	requestGetPayGrades,
} from "services/general";
//#endregion

const useDataRelatedToForm = ({
	loadingRequest,
	setLoadedDataRelatedToEventForm,
}) => {
	//#region State
	const [eventTypes, setEventTypes] = useState([]);
	const [eventSubtypes, setEventSubtypes] = useState([]);
	const [eventGraphics, setEventGraphics] = useState([]);
	const [allDays, setAllDays] = useState([]);
	const [organizers, setOrganizers] = useState([]);
	const [teacherAccounts, setTeacherAccounts] = useState([]);
	const [modalities, setModalities] = useState([]);
	const [locations, setLocations] = useState([]);
	const [inscriptionEventTypes, setInscriptionEventTypes] = useState([]);
	const [allCampus, setAllCampus] = useState([]);
	const [campusEnvironments, setCampusEnvironments] = useState([]);
	const [complementaryServiceAreas, setComplementaryServiceAreas] = useState(
		[]
	);
	const [payGrades, setPayGrades] = useState([]);
	const [extracurricularSections, setExtracurricularSections] = useState([]);
	const [certificationSignatureTypes, setCertificationSignatureTypes] =
		useState([]);
	//#endregion
	const fetchData = async () => {
		loadingRequest.show();
		await Promise.all([
			fillEventTypes(),
			fillEventSubtypes(),
			fillEventGraphics(),
			fillOrganizers(),
			fillModalities(),
			fillLocations(),
			fillAllCampus(),
			fillInscriptionEventTypes(),
			fillAllDays(),
			fillCampusEnvironments(),
			fillTeacherAccounts(),
			fillComplementaryServiceAreas(),
			fillPayGrades(),
			fillExtracurricularSections(),
			fillCertificationSignatureTypes(),
		]);
		loadingRequest.hide();
		setLoadedDataRelatedToEventForm(true);
	};
	const fillEventTypes = async () => {
		const data = await requestGetEventTypes();
		setEventTypes(data);
	};
	const fillEventSubtypes = async () => {
		const data = await requestGetEventSubtypes();
		setEventSubtypes(data);
	};
	const fillEventGraphics = async () => {
		const fetchEventGraphics = await requestGetEventGraphics();
		setEventGraphics(fetchEventGraphics);
	};
	const fillOrganizers = async () => {
		const data = await requestGetOrganizers();
		setOrganizers(data);
	};
	const fillModalities = async () => {
		const data = await requestGetModalities();
		setModalities(data);
	};
	const fillLocations = async () => {
		const data = await requestGetLocations();
		setLocations(data);
	};
	const fillInscriptionEventTypes = async () => {
		const data = await requestGetInscriptionEventTypes();
		setInscriptionEventTypes(data);
	};
	const fillAllDays = async () => {
		const data = await requestGetAllDays();
		setAllDays(data);
	};
	const fillAllCampus = async () => {
		const data = await requestGetAllCampus();
		setAllCampus(data);
	};
	const fillCampusEnvironments = async () => {
		const data = await requestGetCampusEnvironments();
		setCampusEnvironments(data);
	};
	const fillTeacherAccounts = async () => {
		const data = await requestGetTeacherAccounts();
		setTeacherAccounts(data);
	};
	const fillComplementaryServiceAreas = async () => {
		const data = await requestGetComplementaryServiceAreas();
		setComplementaryServiceAreas(data);
	};
	const fillPayGrades = async () => {
		const data = await requestGetPayGrades();
		setPayGrades(data);
	};
	const fillExtracurricularSections = async () => {
		const data = await requestGetExtracurricularSections();
		setExtracurricularSections(data);
	};
	const fillCertificationSignatureTypes = async () => {
		const data = await requestGetCertificationSignatureTypes();
		setCertificationSignatureTypes(data || []);
	};
	return [
		fetchData,
		{
			eventTypes,
			eventSubtypes,
			eventGraphics,
			allDays,
			organizers,
			teacherAccounts,
			modalities,
			locations,
			inscriptionEventTypes,
			allCampus,
			campusEnvironments,
			complementaryServiceAreas,
			payGrades,
			extracurricularSections,
			certificationSignatureTypes,
		},
	];
};

export default useDataRelatedToForm;
